export default {
  SET_LOADING:         (state, val) => { state.loading = val },
  SET_LOADING_DETALLE: (state, val) => { state.loadingDetalle = val },

  SET_CONVERSACIONES: (state, data) => { state.conversaciones = data },
  SET_DETALLE:        (state, data) => { state.detalle = data },

  SET_PAGE:     (state, val) => { state.page = val },
  SET_PER_PAGE: (state, val) => { state.perPage = val },

  SET_FILTRO: (state, { campo, valor }) => {
    state.filtros = { ...state.filtros, [campo]: valor }
  },
  RESET_FILTROS: (state) => {
    state.filtros = { search: '', canal: null, estado: 'open', match_estado: null, con_cliente: null, id_cliente: null }
  }
}
